import React from "react";
import GuideMain from "../components/guide/main-page";
import Layout from "../templates/layout";
import { graphql } from "gatsby";

const Glossary = () => (
  <Layout>
    <GuideMain />
  </Layout>
);

export default Glossary;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
